<template>
  <CustomModal
    id="confirm-report-content-modal"
    class="basic-modal"
    :title="$t('common.modal.confirm_report_content.title')"
    :close-title="$t('common.cancel')"
    :ok-title="$t('common.confirm')"
    @cancel="$emit('cancel')"
    @ok="$emit('ok')"
  >
    <div v-html="$t('common.modal.confirm_report_content.desc')" />
  </CustomModal>
</template>

<script>
export default {
  name: 'confirm-report-content-modal',
};
</script>
